interface Props {
  content?: string;
  title?: string;
  body?: string;
}

export default function MinisiteDescription({ content, title, body }: Props) {
  const html = content || body;
  if (!html && !title) return null;

  return (
    <article className="min-h-80 rounded-2xl bg-card border p-6 overflow-hidden">
      {title && (
        <h2 className="font-bold text-foreground text-xl mb-3">{title}</h2>
      )}
      {html && (
        <div
          className="prose prose-sm max-w-none overflow-hidden break-words text-card-foreground"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </article>
  );
}
